import * as ng from 'angular';

export const StPaginationScroll = ($timeout: ng.ITimeoutService) => (<angular.IDirective>{
    require: 'stTable',
    link: (scope, element, attr, ctrl: any) => {
        let itemByPage = 20;
        let pagination = ctrl.getTableState().pagination;
        let lengthThreshold = 50;
        let timeThreshold = 400;
        let handler = () => {
            // call next page
            // ctrl.slice(pagination.start + itemByPage, itemByPage);
        };
        let promise = null;
        let lastRemaining = 9999;
        let container = ng.element(element.parent());

        container.bind('scroll', () => {
            let remaining = container[0].scrollHeight - (container[0].clientHeight + container[0].scrollTop);

            // if we have reached the threshold and we scroll down
            if (remaining < lengthThreshold && (remaining - lastRemaining) < 0) {

                // if there is already a timer running which has no expired yet we have to cancel it and restart the timer
                if (promise !== null) {
                    $timeout.cancel(promise);
                }
                promise = $timeout(() => {
                    handler();

                    // scroll a bit up
                    container[0].scrollTop -= 500;

                    promise = null;
                }, timeThreshold);
            }
            lastRemaining = remaining;
        });
    }
});

StPaginationScroll.$inject = ['$timeout'];




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-pagination-scroll/st-pagination-scroll.directive.ts